<template>
  <div class="actions">
    <template v-if="state == 'pending'">
      <i @click="openCandidateDetail" class="mr-1 fa fa-eye"></i>
      <i @click="recallUser" class="fa fa-refresh color-pink" :class="{ 'fa-spin': recallingUser }"></i>
    </template>
    <template v-else-if="state == 'confirmed'">
      <i @click="openCandidateDetail" class="mr-1 fa fa-eye"></i>
      <i @click="activateUser" class="fa fa-check color-pink"></i>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AtInternetManagingCandidate from '@/helpers/at_internet/managing_candidate'

export default {
  name: 'AwaitingCandidateTableAction',
  props: ['entityId', 'user', 'state'],
  data() {
    return {
      recallingUser: false
    }
  },
  computed: {
    ...mapGetters({
      isSingleEntity: 'users/isSingleEntity'
    })
  },
  methods: {
    openCandidateDetail() {
      if(this.isSingleEntity || this.entityId) {
        this.$store.commit('dashboard/SET_ACTIVE_CANDIDATE', this.user);
        $('#modalCandidateDetail').modal('show');
      } else {
        let entityId = this.user.user_entities[0].entity_id
        this.$router.push({ name: 'EditUser', params: { entity_id: entityId, user_id: this.user.id } })
      }
    },
    async activateUser() {
      AtInternetManagingCandidate.sendValidateCandidatsEvent();
      this.$store.dispatch('users/getEntitiesForMultiAction', { user: this.user , entityId: this.entityId, action: 'activate' });
      await this.$store.dispatch("dashboard/initDataCandidateBlock", this.entityId);
    },
    async recallUser() {
      AtInternetManagingCandidate.sendReCallCandidatEvent();
      this.recallingUser = true;
      await this.$store.dispatch('users/recallUser', { user: this.user, entityId: this.entityId })
      await this.$store.dispatch("dashboard/initDataCandidateBlock", this.entityId);
      this.recallingUser = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/manager/AwaitingCandidateTableAction.vue